import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "right-content" }
const _hoisted_2 = { class: "top-box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "nav-name" }, "客服组", -1)
const _hoisted_4 = { class: "right-box" }
const _hoisted_5 = { class: "outbox" }
const _hoisted_6 = { class: "more-menu" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "drop-item-menu" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "item" }, "添加客户"),
  /*#__PURE__*/_createElementVNode("p", { class: "item" }, "编辑列表"),
  /*#__PURE__*/_createElementVNode("div", { class: "bt-line" }),
  /*#__PURE__*/_createElementVNode("p", { class: "item" }, "导出Excel"),
  /*#__PURE__*/_createElementVNode("p", { class: "item" }, "批量导入")
], -1)
const _hoisted_8 = { class: "out-line-btn" }
const _hoisted_9 = {
  class: "table-content",
  ref: "tableRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectedMenu = _resolveComponent("SelectedMenu")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_Search = _resolveComponent("Search")!
  const _component_CaretDownOutlined = _resolveComponent("CaretDownOutlined")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_Input = _resolveComponent("Input")!
  const _component_UserTable = _resolveComponent("UserTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.hasSelected)
          ? (_openBlock(), _createBlock(_component_SelectedMenu, {
              key: 0,
              selectRows: _ctx.selectRows,
              viewObj: _ctx.viewObj,
              onCancelSelect: _ctx.handleCancelSelect
            }, null, 8, ["selectRows", "viewObj", "onCancelSelect"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_Input, {
                value: _ctx.searchValue,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
                style: {"width":"250px"},
                placeholder: "搜索姓名/昵称/email/手机/电话/标签"
              }, {
                suffix: _withCtx(() => [
                  _createVNode(_component_SearchOutlined, {
                    style: {"cursor":"pointer"},
                    onClick: _ctx.hadleSearch
                  }, null, 8, ["onClick"])
                ]),
                addonAfter: _withCtx(() => [
                  _createVNode(_component_Popover, {
                    overlayClassName: "search-popover",
                    trigger: "click",
                    placement: "bottomRight"
                  }, {
                    content: _withCtx(() => [
                      _createVNode(_component_Search)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_CaretDownOutlined)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", {
                  class: "cursor",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewNext && _ctx.viewNext(...args)))
                }, "逐条查看"),
                _createVNode(_component_Popover, {
                  overlayClassName: "menu-popover",
                  trigger: "click",
                  placement: "bottomRight"
                }, {
                  content: _withCtx(() => [
                    _hoisted_7
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_CaretDownOutlined)
                    ])
                  ]),
                  _: 1
                })
              ])
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_UserTable, {
        tableHeight: _ctx.tableHeight,
        dataList: _ctx.dataList,
        columns: _ctx.columns,
        pagination: _ctx.pagination,
        onTableChange: _ctx.handleTableChange,
        selectedRowKeys: _ctx.selectedRowKeys,
        onOnSelectChange: _ctx.onSelectChange
      }, null, 8, ["tableHeight", "dataList", "columns", "pagination", "onTableChange", "selectedRowKeys", "onOnSelectChange"])
    ], 512)
  ]))
}